module.exports = __webpack_public_path__ + "static/media/19ESCAP7.a9ea9f00.jpg";